//@ts-check
import * as THREE from "three";

/**
 * @module Ground
 */

/**
 * Creates Default ground and adds to the scene
 */
export function createDefaultGround() {
  var scope = this;

  var groundPlane = new THREE.PlaneGeometry(scope.groundScale, scope.groundScale, 100, 100);

  scope.ground = new THREE.Mesh(groundPlane, scope.groundMaterial);
  scope.ground.layers.enable(1); // layer 1
  scope.ground.name = "sceneGround";
  scope.ground.receiveShadow = true;
  scope.ground.visible = this.showGround;

  scope.scene.add(scope.ground);
}

/**
 * Sets global ground properties and calls updateGround()
 * @param {boolean} show - Show ground
 * @param {Number} color - Hex Color
 * @param {Number} opacity - Opacity
 * @param {Number} size - Size
 * @param {Number} height - Height
 */
export function setSceneGround(show, color, opacity, size, height) {
  this.showGround = show;
  this.groundColor = color;
  this.groundOpacity = opacity;
  this.groundHeight = height;
  this.groundScale = size;
  this.updateGround();
}

/**
 *Adds ground per scope.boundingSphere
 */
export function addGround() {

  var scope = this;

  var length = 1;
  var x = 0;
  var y = 0;
  var z = 0;

  if (scope.boundingSphere !== null) {
    length = scope.boundingSphere.radius;
    x = scope.boundingSphere.center.x;
    y = scope.boundingSphere.center.y;
    z = scope.boundingBox.min.z;
  }

  scope.scene.remove(scope.ground);

  var groundPlane = new THREE.PlaneGeometry(length * scope.groundScale, length * scope.groundScale);
  scope.groundMaterial.color = this.parseColor(scope.groundColor);
  scope.groundMaterial.opacity = scope.groundOpacity;

  scope.ground = new THREE.Mesh(groundPlane, scope.groundMaterial);
  scope.ground.layers.enable(1); // layer 1
  scope.ground.name = "sceneGround";
  scope.ground.receiveShadow = true;

  scope.scene.add(scope.ground);

  if (scope.modelScene.children != 0) {
    scope.ground.position.set(x, y, z);
    scope.defaultGroundPosition = scope.ground.position.z;
    scope.updateGroundLevel(scope.groundHeight);
  }
  scope.ground.visible = scope.showGround;

}

/**
 * Updates ground per global ground properties
 */
export function updateGround() {
  var scope = this;

  scope.groundMaterial.color = this.parseColor(scope.groundColor);
  scope.groundMaterial.opacity = scope.groundOpacity;

  scope.defaultGroundPosition = scope.ground.position.z;
  scope.ground.visible = scope.showGround;

  scope.updateGroundLevel(scope.groundHeight);
}


/**
 * Updates the ground's level
 * @param {Number} groundLevel - Ground level
 * @returns {Object} Return success or error messages 
 * { status:  mesage: }
 */
export function updateGroundLevel(groundLevel) {
  var scope = this;
  var z = 0;
  if (scope.boundingSphere !== null) {
    z = scope.boundingBox.min.z;
  }
  try {
    if (scope.ground != undefined || scope.ground != null) {
      scope.ground.position.z = z;
      scope.ground.translateZ(groundLevel);
      scope.ground.updateMatrix();

      //viewerMgrInstance.render();
      var returnValue = {
        "status": "success",
        "message": "Ground level is updated successfully."
      }
      return returnValue;
    }
    else {
      var returnValue = {
        "status": "failed",
        "message": "ERROR : Ground is not added in the viewer or it is undefined."
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      "status": "failed",
      "message": "System Error :" + err.message
    }
    return returnValue;
  }
}

